import React from "react";
import {
  Box,
  Chip,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "convertupleads-theme";
import ColorBox from "./ColorBox";

const DATA = [
  {
    title: "Primary",
    main: "primary.main",
    mainColorCode: "#346FEF",
    dark: "primary.dark",
    darkColorCode: "#004ABB",
    light: "primary.light",
    lightColorCode: "#d6e2fb",
  },
  {
    title: "Secondary",
    main: "secondary.main",
    mainColorCode: "#924CFF",
    dark: "secondary.dark",
    darkColorCode: "#5D00C2",
    light: "secondary.light",
    lightColorCode: "#e9dbff",
  },
  {
    title: "Error",
    main: "error.main",
    mainColorCode: "#EC131F",
    dark: "error.dark",
    darkColorCode: "#cf101b",
    light: "error.light",
    lightColorCode: "#fbcfd2",
  },
  {
    title: "Warning",
    main: "warning.main",
    mainColorCode: "#F79009",
    dark: "warning.dark",
    darkColorCode: "#d97e07",
    light: "warning.light",
    lightColorCode: "#fde8cd",
  },
  {
    title: "Info",
    main: "info.main",
    mainColorCode: "#00BEC5",
    dark: "info.dark",
    darkColorCode: "#00a7ad",
    light: "info.light",
    lightColorCode: "#ccf2f3",
  },
  {
    title: "Success",
    main: "success.main",
    mainColorCode: "#008951",
    dark: "success.dark",
    darkColorCode: "#007847",
    light: "success.light",
    lightColorCode: "#cce7dc",
  },
];

const StylesList = styled("ul")(({ theme }) => ({
  padding: theme.spacing(3, 5),
  "& li": { marginBottom: theme.spacing(1),fontSize:14 },
}));

const ColorPaletteComponent = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Default colors
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          The theme exposes the following default palette colors (accessible
          under <strong>theme.palette.*</strong>):
        </Typography>
        <StylesList>
          <li>
            <Chip color={"primary"} variant={"outlined"} label={"primary"} size={"xSmall"} /> - for
            primary interface elements.
          </li>
          <li>
            <Chip variant={"outlined"} label={"secondary"} color={"secondary"} size={"xSmall"} /> -
            for secondary interface elements.
          </li>
          <li>
            <Chip variant={"outlined"} label={"error"} color={"error"} size={"xSmall"} /> - for
            elements that the user should be made aware of.
          </li>
          <li>
            <Chip variant={"outlined"} label={"warning"} color={"warning"} size={"xSmall"} /> - for
            potentially dangerous actions or important messages.
          </li>
          <li>
            <Chip variant={"outlined"} label={"info"} color={"info"} size={"xSmall"} /> - for
            highlighting neutral information.
          </li>
          <li>
            <Chip variant={"outlined"} label={"success"} color={"success"} size={"xSmall"} /> - for
            indicating the successful completion of an action that the user
            triggered.
          </li>
        </StylesList>
      </Box>
      <Box sx={{ width: "95%", alignSelf: "center" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Color</TableCell>
              <TableCell align={"center"}>Main</TableCell>
              <TableCell align={"center"}>dark</TableCell>
              <TableCell align={"center"}>light</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {DATA.map((data, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Typography variant={"subtitle1"}>{data.title}</Typography>
                  </TableCell>
                  <TableCell>
                    <ColorBox colorCode={data.mainColorCode}  color={data.main} />
                  </TableCell>
                  <TableCell>
                    <ColorBox colorCode={data.darkColorCode} color={data.dark} />
                  </TableCell>
                  <TableCell>
                    <ColorBox colorCode={data.lightColorCode} color={data.light} />
                  </TableCell>
                </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Stack>
  );
};

export default ColorPaletteComponent;
